import { Injectable } from '@nestjs/common';
import { CommonResponseModel } from '@needle-management/shared-models';
import { InjectRepository } from '@nestjs/typeorm';
import { Not, Repository } from 'typeorm';
import { StockOutEntity } from './entities/stock-out.entity';
import { ReturnStatusEnum } from '@needle-management/shared-models';


@Injectable()
export class StockOutService {
  constructor(
    @InjectRepository(StockOutEntity)
    private readonly stockOutRepo: Repository<StockOutEntity>,

  ) {}

    async getStockOutData(): Promise<CommonResponseModel> {
        try{
            let stock = await this.stockOutRepo.find({where:{returnStatus: Not(ReturnStatusEnum.Received)}});
            if(stock.length > 0){
                return new CommonResponseModel(true,1,"retrived report successfully. ", stock)
            }
            else{
                return new CommonResponseModel(false,0,"Something went wrong. ", )
            }
        }catch (error) {
            return error;
        }
    }
}
